// AXIS ZERO - Configuration Constants
// VISUAL: Hardcore Minimal Esport Neon Style
// All game constants in one place

export const CONFIG = {
  // Physics (DO NOT CHANGE)
  GRAVITY: 2300,
  JUMP_VELOCITY: -860,
  START_SPEED: 520,
  MAX_SPEED: 1200,
  SPEED_INCREASE: 15,
  PRACTICE_SPEED_MULT: 0.85,

  // Game feel (DO NOT CHANGE)
  COYOTE_TIME: 0.10,
  JUMP_BUFFER: 0.12,

  // Player dimensions (DO NOT CHANGE hitboxes)
  PLAYER_WIDTH: 40,
  PLAYER_HEIGHT: 40,
  PLAYER_GROUND_Y_OFFSET: 100,

  // Obstacle settings (DO NOT CHANGE)
  OBSTACLE_MIN_WIDTH: 30,
  OBSTACLE_MAX_WIDTH: 50,
  OBSTACLE_MIN_HEIGHT: 60,
  OBSTACLE_MAX_HEIGHT: 100,
  OBSTACLE_GAP_MIN: 330,
  OBSTACLE_GAP_MAX: 650,
  
  // Safety guard - minimum gap to ensure patterns are survivable
  MIN_SAFE_GAP: 180,

  // Early game fairness (DO NOT CHANGE)
  EARLY_GAME_DURATION: 5,
  EARLY_GAME_GAP_MULT: 1.3,

  // Level generation timing (DO NOT CHANGE)
  FIRST_TWIST_TIME: 10,
  PATTERN_CYCLE: ['SAFE', 'SAFE', 'SKILL', 'SAFE', 'TWIST'],

  // Death effects
  DEATH_SLOW_MO_DURATION: 0.2,
  DEATH_SLOW_MO_FACTOR: 0.3,
  SCREEN_SHAKE_DURATION: 0.12,
  SCREEN_SHAKE_INTENSITY: 6,
  DEATH_FLASH_DURATION: 0.08,

  // Trail - optimized (3-4 afterimages max, no glow)
  TRAIL_MAX_LENGTH: 4,
  TRAIL_SPAWN_INTERVAL: 0.025,
  TRAIL_FADE_SPEED: 4,
  
  // Near miss (DO NOT CHANGE detection logic)
  NEAR_MISS_DISTANCE: 25,
  NEAR_MISS_SPARK_COUNT: 6,

  // Streak system - High Mode at streak >= 5
  STREAK_TIMEOUT: 2.8,
  HIGH_MODE_THRESHOLD: 5,
  HIGH_MODE_SPEED_MULT: 1.03,
  HIGH_MODE_JUMP_MULT: 1.06,
  HIGH_MODE_GLOW_INCREASE: 1.3,

  // Background streaks
  BG_STREAK_BASE_ALPHA: 0.03,
  BG_STREAK_MAX_ALPHA: 0.12,
  BG_STREAK_COUNT: 20,

  // Ground haze
  GROUND_HAZE_HEIGHT: 90,
  GROUND_HAZE_ALPHA: 0.15,

  // ============================================
  // VISUAL STYLE
  // ============================================
  
  COLORS: {
    BACKGROUND: '#000000',
    
    // Player
    PLAYER: '#00E5FF',
    PLAYER_GLOW: 'rgba(0, 229, 255, 0.8)',
    PLAYER_TRAIL: '#00E5FF',
    
    // Obstacles (modular outline squares)
    OBSTACLE_FILL: 'transparent',
    OBSTACLE_STROKE: '#00E5FF',
    OBSTACLE_GLOW: 'rgba(0, 229, 255, 0.4)',
    
    // Ground
    FLOOR_LINE: '#00E5FF',
    FLOOR_GLOW: 'rgba(0, 229, 255, 0.6)',
    FLOOR_HAZE: 'rgba(0, 229, 255, 0.08)',
    
    // Effects
    PARTICLE: '#00E5FF',
    NEAR_MISS_SPARK: '#00E5FF',
    DEATH_FLASH: '#FFFFFF',
    BG_STREAK: 'rgba(0, 229, 255, 0.06)',
    
    // UI
    SCORE_TEXT: '#00E5FF',
    STREAK_TEXT: '#00E5FF',
    TEXT_PRIMARY: '#FFFFFF',
    TEXT_SECONDARY: '#666666',
  },

  // High Mode colors (Red)
  COLORS_HIGH_MODE: {
    PLAYER: '#FF1744',
    PLAYER_GLOW: 'rgba(255, 23, 68, 0.9)',
    PLAYER_TRAIL: '#FF1744',
    OBSTACLE_STROKE: '#FF1744',
    OBSTACLE_GLOW: 'rgba(255, 23, 68, 0.5)',
    FLOOR_LINE: '#FF1744',
    FLOOR_GLOW: 'rgba(255, 23, 68, 0.7)',
    FLOOR_HAZE: 'rgba(255, 23, 68, 0.1)',
    PARTICLE: '#FF1744',
    NEAR_MISS_SPARK: '#FF1744',
    BG_STREAK: 'rgba(255, 23, 68, 0.08)',
    SCORE_TEXT: '#FF1744',
    STREAK_TEXT: '#FF1744',
  },

  // Obstacle module size for visual rendering
  OBSTACLE_MODULE_SIZE: 16,
  OBSTACLE_VARIANTS: ['standard'],

  // UI
  RESTART_DELAY: 0.1,
};

// Death messages - clean, short
export const DEATH_MESSAGES = [
  "GG",
  "REKT", 
  "F",
  "AGAIN",
  "ALMOST",
  "CLOSE",
  "NOPE",
  "RIP",
];

// Pattern definitions (DO NOT CHANGE)
export const PATTERNS = {
  SAFE: {
    obstacleCount: 1,
    gapMultiplier: 1.5,
    heightRange: [0.5, 0.7],
    hasTelegraph: false,
  },
  SKILL: {
    obstacleCount: 2,
    gapMultiplier: 1.0,
    heightRange: [0.6, 0.9],
    hasTelegraph: false,
  },
  TWIST: {
    obstacleCount: 1,
    gapMultiplier: 1.2,
    heightRange: [0.8, 1.0],
    hasTelegraph: true,
    telegraphDelay: 0.22,
  },
};

export default CONFIG;
